"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Select = _interopRequireDefault(require("../Select/Select"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var TabNavigation =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TabNavigation, _PureComponent);

  function TabNavigation(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TabNavigation);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TabNavigation).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onSelectChange", function (_ref) {
      var value = _ref.value;

      _this.props.onTabClick(parseInt(value, 10));
    });
    _this._selectItems = _react.Children.map(props.children, function (tab, i) {
      if (tab) {
        return {
          label: tab.props.label,
          value: i.toString()
        };
      }
    });
    return _this;
  }

  (0, _createClass2.default)(TabNavigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          selectedIndex = _this$props.selectedIndex,
          onTabClick = _this$props.onTabClick;
      var classes = (0, _classnames.default)('TabNavigation', className);
      return _react.default.createElement("nav", {
        className: classes,
        role: "tablist"
      }, _react.default.createElement("div", {
        className: "TabNavigation-links"
      }, _react.Children.map(children, function (tab, i) {
        if (tab) {
          return (0, _react.cloneElement)(tab, {
            active: selectedIndex === i,
            index: i,
            onTabClick: onTabClick
          });
        }
      })), _react.default.createElement(_Select.default, {
        key: new Date(),
        className: "TabNavigation-select",
        defaultValue: selectedIndex.toString(),
        items: this._selectItems,
        onChange: this._onSelectChange
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return TabNavigation;
}(_react.PureComponent);

exports.default = TabNavigation;
(0, _defineProperty2.default)(TabNavigation, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** Children should only be made up of Tab components or a false boolean value when a condition to render the Tab is false. */
  children: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.bool])).isRequired,

  /** The selected tab index. Automatically passed from Tabs, do not set manually. */
  selectedIndex: _propTypes.default.number,

  /** The method to call when a tab is clicked. Automatically passed from Tabs, do not set manually. */
  onTabClick: _propTypes.default.func
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TabNavigation, "TabNavigation", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Tabs/TabNavigation.jsx");
  leaveModule(module);
})();

;